import React from "react";
import styled from "styled-components";
import PlusImage from "../assets/icon/ProfileMore.svg";
import PixelVideo from "../assets/images/pixcel_battle_encoding.mp4";
import GarageImage from "../assets/images/garage.jpeg";
import GaragePunkLogo from "../assets/icon/GaragePunkLogo.png";
import PixelLogo from "../assets/icon/pixelbattle_logo.png";
import { useInView } from "react-intersection-observer";
import { animated, useSpring } from "react-spring";
import Title from "./Title";
import { device } from "../styles/media-query";
import { useMyMediaQuery } from "../hooks/useMediaQuery";

const Container = styled.section`
  background: #1c1c1c;

  ${device.tablet} {
    padding: 12rem 6rem;
  }

  ${device.mobile} {
    padding: 8rem 2rem;
  }

  ${device.desktop} {
    padding: 20rem 4rem;
    max-width: 1080px;
    margin: 0 auto;
  }
`;

const PortfolioList = styled.ul`
  ${device.desktop} {
    margin-top: 12rem;
  }

  margin-top: 6rem;

  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const PortfolioImageContainer = styled.div`
  ${device.desktop} {
    width: 600px;
    height: 600px;
  }

  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  display: inline-flex;
`;

const PortfolioImage = styled.img`
  vertical-align: top;
  max-width: 100%;
  transition: all 0.3s;

  &:hover {
    transform: scale(1.1);
  }

  ${device.mobile} {
    width: calc(100vw - 4rem) !important;
    height: calc(100vw - 4rem);
  }

  ${device.tablet} {
    width: calc(100vw - 12rem) !important;
    height: calc(100vw - 12rem);
  }

  ${device.desktop} {
    width: 600px;
    height: 600px;
  }

  object-fit: cover;
  //object-position: center center;
`;

const PortfolioVideo = styled.video`
  transition: all 0.3s;

  &:hover {
    transform: scale(1.1);
  }

  ${device.mobile} {
    width: calc(100vw - 4rem) !important;
    height: calc(100vw - 4rem);
  }

  ${device.tablet} {
    width: calc(100vw - 12rem) !important;
    height: calc(100vw - 12rem);
  }

  ${device.desktop} {
    width: 600px;
    height: 600px;
  }

  object-fit: cover;
  //object-position: center center;
`;

const PlusImg = styled.img<{ first?: boolean }>`
  transition: all 0.3s ease-in;
  width: 5vw;
  height: 5vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  pointer-events: none;
`;

const TitleContainer = styled.div<{ seconds?: boolean }>`
  margin-top: 4rem;

  ${device.mobile} {
    margin-top: 2rem;
  }

  transition: all 0.3s ease-in-out;
  display: inline-block;
  opacity: 1;
  //top: 50%;
  //transform: translateY(-46%);
  top: 200px;
  left: 440px;

  font-size: 3vw;

  ${device.desktop} {
    position: absolute;
    margin: 0;
    top: 200px;
    left: 550px;
    ${({ seconds }) => seconds && `left : 740px`}
  }

  @media (max-width: 1280px) {
    ${({ seconds }) => seconds && `left : calc(50% + 250px)`}
  }
}
`;

const PortfolioItem = styled.li`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  margin-bottom: 6rem;

  ${device.desktop} {
    margin-bottom: 12rem;
  }

  ${device.desktop} {
    &:last-child {
      margin-bottom: 0;
      justify-content: center;
      align-items: center;
    }

    // ${PortfolioVideo} {
    //   &:hover {
    //     width: 100%;
    //     margin-left: 0;
    //     margin-right: 0;
    //
    //     & ~ ${TitleContainer} {
    //       opacity: 0;
    //     }
    //
    //     & ~ ${PlusImg} {
    //       opacity: 0.6;
    //     }
    //   }
    // }
  }
`;

const GameDescription = styled.p`
  color: white;
  font-size: 2.4rem;
  line-height: 36px;

  ${device.mobile} {
    font-size: 1.6rem;
  }

  transition: all 0.4s ease-in-out;
  width: 100%;
  margin-top: 20px;
  ${device.mobile} {
    margin-top: 0;
  }
`;

function Portfolio() {
  const { isDesktop } = useMyMediaQuery();
  const { ref, inView } = useInView();

  const { ref: pixelRef, inView: pixelInView } = useInView({});

  const garageTextStyle = useSpring({
    delay: 200,
    from: { transform: "translateY(30px)", opacity: 0 },
    to: {
      transform: inView ? "translateY(0px)" : "translateY(30px)",
      opacity: inView ? 1 : 0,
    },
    config: { duration: 500 },
  });

  const pixelStyle = useSpring({
    delay: 200,
    from: {
      transform: `translateY(30px)`,
      opacity: 0,
    },
    to: {
      transform: pixelInView ? "translateY(0px)" : `translateY(30px)`,
      opacity: pixelInView ? 1 : 0,
    },
    config: { duration: 500 },
  });

  const onMoverOver = (id: number) => {
    if (isDesktop) {
      const image = document.getElementById(`image${id}`);
      const text = document.getElementById(`inner_text${id}`);
      const plus = document.getElementById(`plus${id}`);
      if (image && text && plus) {
        // image.style.width = "100%";
        // // image.style.height = "800px";
        // image.style.objectFit = "cover";
        // text.style.opacity = "0";
        plus.style.opacity = "1";
      }
    }
  };

  const onMoverLeave = (id: number) => {
    if (isDesktop) {
      const image = document.getElementById(`image${id}`);
      const text = document.getElementById(`inner_text${id}`);
      const plus = document.getElementById(`plus${id}`);
      if (image && text && plus) {
        // image.style.width = "480px";
        // image.style.height = "480px";
        // image.style.objectFit = "cover";
        text.style.opacity = "1";
        plus.style.opacity = "0";
      }
    }
  };

  const { ref: titleRef, inView: titleInView } = useInView({
    rootMargin: "-360px 0px 0px 0px",
    triggerOnce: true,
  });

  const titleStyle = useSpring({
    delay: 200,
    to: {
      transform: titleInView ? "translateY(0)" : "translateY(30px)",
      opacity: titleInView ? 1 : 0,
    },
    config: { duration: 500 },
  });

  const goToLink = (link: string) => {
    window.open(link, "_blank");
  };

  return (
    <Container id={"portfolio"}>
      <div ref={titleRef}>
        <animated.div style={titleStyle}>
          <Title
            text={
              <>
                Our <br /> Portfolio
              </>
            }
          />
        </animated.div>
        <PortfolioList>
          <PortfolioItem
            onClick={() => {
              goToLink("https://garagepunk.io");
            }}
          >
            <PortfolioImageContainer>
              <PortfolioImage
                src={GarageImage}
                id={"image1"}
                onMouseOver={() => onMoverOver(1)}
                onMouseLeave={() => onMoverLeave(1)}
              />
              <PlusImg
                src={PlusImage}
                width={"5vw"}
                height={"5vw"}
                id={"plus1"}
                first={true}
              />
            </PortfolioImageContainer>

            <TitleContainer
              ref={ref}
              id={"inner_text1"}
              onMouseOver={() => onMoverOver(1)}
              onMouseLeave={() => onMoverLeave(1)}
            >
              <animated.div style={garageTextStyle}>
                <img
                  src={GaragePunkLogo}
                  width={isDesktop ? 360 : 260}
                  alt={"pixel"}
                />
                <GameDescription>
                  The One & Only Mobility NFT for Car Collector
                </GameDescription>
              </animated.div>
            </TitleContainer>
          </PortfolioItem>
          <PortfolioItem>
            <PortfolioImageContainer>
              <PortfolioVideo
                src={PixelVideo}
                id={"image2"}
                onMouseOver={() => onMoverOver(2)}
                onMouseLeave={() => onMoverLeave(2)}
                loop
                playsInline
                autoPlay
                muted
              />
            </PortfolioImageContainer>
            <PlusImg
              src={PlusImage}
              width={"5vw"}
              height={"5vw"}
              id={"plus2"}
            />
            <TitleContainer
              ref={pixelRef}
              id={"inner_text2"}
              seconds
              onMouseOver={() => onMoverOver(2)}
              onMouseLeave={() => onMoverLeave(2)}
            >
              <animated.div style={pixelStyle}>
                <img
                  src={PixelLogo}
                  width={isDesktop ? 240 : 200}
                  alt={"pixel"}
                />
                <GameDescription>
                  Pixel Mechanic Survival Battle Royal
                </GameDescription>
              </animated.div>
            </TitleContainer>
          </PortfolioItem>
        </PortfolioList>
      </div>
    </Container>
  );
}

export default Portfolio;
